<template>
  <div class="eu-display_flex_md eu-display_none emd-user-menu-footer eu-align-items_center eu-justify_space-between eu-px_4">
    <div class="eu-display_flex eu-justify_center eu-column">
      <span
        class="emd-text _color_default _type_bold eu-text-overflow"
        data-testid="user-name"
      >{{ `${user.first_name} ${user.last_name}` }}</span>
      <span
        class="emd-text _color_subtle _size_small eu-text-overflow"
        data-testid="user-email"
      >{{ user.email }}</span>
    </div>
    <slot></slot>
  </div>
</template>

<script>

export default {
  name: 'EmdUserMenuFooter',
  props: {
    user: {
      type: Object,
      required: true,
      validator: value => ['first_name', 'last_name', 'email'].every(key => key in value)
    }
  }
}
</script>
